import script from "./EmployeeViewADocumentLive.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeViewADocumentLive.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeViewADocumentLive.vue?vue&type=style&index=0&id=6f32701d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f32701d"]])

export default __exports__